module.exports = __webpack_public_path__ + "media/images/Rectangle-6367dd14f8482e63534154970486e8be.png";